import { captData, structure, getCheckoutBySCId, generateOrder, createOrder, getAuditServiceSave } from "../api/api";
import { getUpdateStatus } from '../components/Util/UpdateStatusAPI';
import { auditErrorRequest } from "../Util/AuditErrorRequest";

const win: any = window;
var serverURL = win["base_portal_url"];
var errorPage = win["errorPageURL"];
var timeoutErrorPage = win["timeout_error_page"];
const retryCount = win['AllowedAPIRetryCount'];

const SequenceManagerAction = {
    INIT : 'INIT',
    SET_PRODUCT_KEY : 'SET_PRODUCT_KEY',
    SET_PRODUCT_KEY_COMPLETE : 'SET_PRODUCT_KEY_COMPLETE',
    LOAD_PRODUCT_OFFER_COMPLETE : 'LOAD_PRODUCT_OFFER_COMPLETE',
    CREATE_SHOPPING_CART_COMPLETE : 'CREATE_SHOPPING_CART_COMPLETE',
    QUALIFY_PRODUCTS_COMPLETE : 'QUALIFY_PRODUCTS_COMPLETE',
    SHOPPING_CART_PATCH_SIGNATURE_COMPLETE : 'SHOPPING_CART_PATCH_SIGNATURE_COMPLETE',
    SHOPPING_CART_VALIDATION_COMPLETE : 'SHOPPING_CART_VALIDATION_COMPLETE',
    UPDATE_VALIDATE_CART_COMPLETE : 'UPDATE_VALIDATE_CART_COMPLETE',
    SHOPPING_CART_UPDATE_COMPLETE : 'SHOPPING_CART_UPDATE_COMPLETE',
    STRUCTURE_UPDATE_COMPLETE : 'STRUCTURE_UPDATE_COMPLETE',
    CAPTURE_DATA_COMPLETE : 'CAPTURE_DATA_COMPLETE',
    GENERIC_ERROR : 'GENERIC_ERROR',
    SECTION_COMPLETE : "SECTION_COMPLETE",
    DISPLAY_NEXT_SECTION : "DISPLAY_NEXT_SECTION",
    DISPLAY_PREVIOUS_SECTION : "DISPLAY_PREVIOUS_SECTION",
    STRUCTURE_UPDATE_SUCCESS : 'STRUCTURE_UPDATE_SUCCESS',
    STRUCTURE_UPDATE_FAILURE : 'STRUCTURE_UPDATE_FAILURE',
    GET_CHECKOUT_SUCCESS : 'GET_CHECKOUT_SUCCESS',
    GET_CHECKOUT_FAILURE : 'GET_CHECKOUT_FAILURE',
    GET_CHECKOUT_COMPLETE : 'GET_CHECKOUT_COMPLETE',
    CAPTURE_DATA_SUCCESS : 'CAPTURE_DATA_SUCCESS',
    CAPTURE_DATA_FAILURE : 'CAPTURE_DATA_FAILURE',
    DISPLAY_SECTION : 'DISPLAY_SECTION',
    GENERATE_ORDER_SUCCESS : 'GENERATE_ORDER_SUCCESS',
    GENERATE_ORDER_FAILURE : 'GENERATE_ORDER_FAILURE',
    CREATE_ORDER_SUCCESS : 'CREATE_ORDER_SUCCESS',
    CREATE_ORDER_FAILURE : 'CREATE_ORDER_FAILURE',
    CREATE_ORDER_COMPLETE : 'CREATE_ORDER_COMPLETE',
    SHOPPING_CART_SIM_TYPE : 'SHOPPING_CART_SIM_TYPE',
    GENERAL_ERROR_MODAL : 'GENERAL_ERROR_MODAL'
}

let structureCounter = 0;
let captureCounter = 0;
let getCheckoutCounter = 0;
let createOrderCounter = 0;
let generateCheckoutOrderCount = 0;

const setProductKey = () => {
    return function (dispatch: any) {
        dispatch({
            type: SequenceManagerAction.SET_PRODUCT_KEY, payload: {
                productKey: sessionStorage.getItem("productKey"),
                productURL: sessionStorage.getItem("productURL"),
                productCategory: sessionStorage.getItem("productCategory"),
                planType: sessionStorage.getItem("planType"),
                journey: sessionStorage.getItem("journey")
            }
        });
        dispatch({ type: SequenceManagerAction.SET_PRODUCT_KEY_COMPLETE });
    }
}

const captureData = () => {
  return function (dispatch: any, getState: any) {
    const state = getState();
    const sectionsVisited = state.SequenceManager.sectionsVisited;
    captData()
      .then((response: any) => {
        if (sectionsVisited[sectionsVisited.length - 1] === "PersonalDetails") {
          win.MixpanelTracker.trackEvent("Capture Personal Information", {
            personal_info: "success",
          });
        }
        dispatch({  type: SequenceManagerAction.CAPTURE_DATA_SUCCESS, payload: response, });
        dispatch({ type: SequenceManagerAction.CAPTURE_DATA_COMPLETE });
      })
      .catch((error) => {
        //Display error
        dispatch({ type: SequenceManagerAction.CAPTURE_DATA_SUCCESS, payload: error?.response, });
        if (error?.response?.status) {
          dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error, });
            if ( sectionsVisited[sectionsVisited.length - 1] === "PersonalDetails" ) {
              win.MixpanelTracker.trackEvent("Capture Personal Information", {
                personal_info: "fail",
              });
            }
        } else {
          ++captureCounter;
          if (captureCounter < retryCount) {
            dispatch(captureData());
          } else {
             if ( sectionsVisited[sectionsVisited.length - 1] === "PersonalDetails" ) {
              win.MixpanelTracker.trackEvent("Capture Personal Information", {
                personal_info: "fail",
              });
            }
            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error,});
          }
        }
      });
  };
};

const getStructure = () => {
    return function (dispatch: any) {
        structure()
            .then((response: any) => {
                // getUpdateStatus("CHECKOUT_STRUCTURE", response?.status);
                // getUpdateStatus("CHECKOUT_STRUCTURE", response?.status);
                dispatch({ type: SequenceManagerAction.STRUCTURE_UPDATE_SUCCESS, payload: response.data });
                dispatch({ type: SequenceManagerAction.STRUCTURE_UPDATE_COMPLETE });
            })
            .catch((error) => {
                //Display error
                // getUpdateStatus("CHECKOUT_STRUCTURE", error?.response?.status);
                if (error?.response?.status) {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                } else {
                    ++structureCounter
                    if (structureCounter < retryCount) {
                        dispatch(getStructure());
                    } else {
                        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                }
            })
    }
}

const getCheckout = () => {
    return function (dispatch: any) {
        getCheckoutBySCId().then((response: any) => {
            console.log(response);
            getUpdateStatus("GET_CAPTURE_STRUCTURE", response?.status);
            dispatch({ type: SequenceManagerAction.GET_CHECKOUT_SUCCESS, payload: response.data });
            dispatch({ type: SequenceManagerAction.GET_CHECKOUT_COMPLETE });
        })
            .catch((error) => {
                //Display error
                // getUpdateStatus("GET_CAPTURE_STRUCTURE", error?.response?.status);
                if (error?.response?.status) {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                } else {
                    ++getCheckoutCounter
                    if (getCheckoutCounter < retryCount) {
                        dispatch(getCheckout());
                    } else {
                        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                }
            })
    }
}

const displayNextSection = () => {
    return function (dispatch: any) {
        dispatch({ type: SequenceManagerAction.DISPLAY_NEXT_SECTION });
    }
}

const displayPrevSection = (steps: any = 1) => {
    return function (dispatch: any) {
        dispatch({ type: SequenceManagerAction.DISPLAY_PREVIOUS_SECTION, payload: steps });
    }
}

const displaySection = (section: any, params: any = {}) => {
    return function (dispatch: any) {
        dispatch({ type: SequenceManagerAction.DISPLAY_SECTION, payload: { section: section, params: params } });
    }
}

const generateCheckoutOrder = (cartId: any, journeyName: any, simSwapPhoneNumber?:any) => {
    return function (dispatch: any) {
        generateOrder(cartId, journeyName, simSwapPhoneNumber ).then((response) => {
            dispatch({ type: SequenceManagerAction.GENERATE_ORDER_SUCCESS, payload: { response: response.data } });
        })
          .catch((error) => {
                    const obj =JSON.parse(error?.config?.data)
                    const status = error?.response?.status
                     if (error?.response?.status) {
                        if (status===504){
                            ++generateCheckoutOrderCount
                            if (generateCheckoutOrderCount < retryCount){
                                dispatch( generateCheckoutOrder(obj?.shoppingCartId, obj?.JourneyName, obj?.simSwapPhoneNumber))
                            } else {
                                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                            }
                        } else {
                            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                        }
                    } else if(obj?.JourneyName === "NEW_NUMBER_eSIM" ||obj?.JourneyName === "Cold_SSA"){
                            ++generateCheckoutOrderCount
                            if (generateCheckoutOrderCount < retryCount){
                                dispatch( generateCheckoutOrder(obj?.shoppingCartId, obj?.JourneyName, obj?.simSwapPhoneNumber))
                             } else {
                                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                            }
                    } else {
                                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                });
    }
}

const createOrderId = () => {
    return function (dispatch: any) {
        createOrder()
            .then((response) => {
                dispatch({ type: SequenceManagerAction.CREATE_ORDER_SUCCESS, payload: { response: response } });
                dispatch({ type: SequenceManagerAction.CREATE_ORDER_COMPLETE });
            })
            .catch((error) => {
                //Display error
                if (error?.response?.status) {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                } else {
                    ++createOrderCounter
                    if (createOrderCounter < retryCount) {
                        dispatch(createOrder());
                    } else {
                        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                }
            })    
    }
}

const callAuditServiceApi = (SequenceManager: any, shoppingCartId: any, currentSection?:any) => {
    const req = auditErrorRequest(SequenceManager, shoppingCartId,currentSection);

    const { rtl } = SequenceManager;

    return function () {
        getAuditServiceSave(req)
            .then(() => {
                    if(req?.Status === "504") {
                        window.location.href = serverURL + timeoutErrorPage+`?value=Timeout`;
                        // window.location.href = serverURL + errorPage + `?errorSource=${rtl ? "التجارة الإلكترونية" : "ecommerce"}`;
                    } else {
                        window.location.href = serverURL + errorPage + `?errorSource=${rtl ? "التجارة الإلكترونية" : "ecommerce"}`;
                    }
            }).catch(()=> {
                if(req?.Status === "504") {
                    window.location.href = serverURL + timeoutErrorPage+`?value=Timeout`;
                     // window.location.href = serverURL + errorPage + `?errorSource=${rtl ? "التجارة الإلكترونية" : "ecommerce"}`;
                } else {
                    window.location.href = serverURL + errorPage + `?errorSource=${rtl ? "التجارة الإلكترونية" : "ecommerce"}`;
                }
            })
    }
}

export { SequenceManagerAction, setProductKey, displayNextSection, displayPrevSection, displaySection, getStructure, getCheckout, captureData, generateCheckoutOrder, createOrderId, callAuditServiceApi };

